var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"menuWrapper",staticClass:"rightMenu"},[_c('div',{staticClass:"rightMenuBody",class:{
      withFooter: _vm.$slots.footer,
      menuSticked: _vm.$store.state.sticked,
    }},[_vm._t("default")],2),_c('div',{staticClass:"rightMenuFooter"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }